<template>
	<el-dialog
		title="合并资源"
		:visible.sync="dialogVisible"
		width="35%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="plan-dialog">
		<div class="msg">已选择 2 个资源进行合并</div>
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 合并 -->
				<el-col :span="24">
					<el-form-item label="合并资源" prop="resourceIds">
						<el-transfer
							v-loading="loading"
							v-model="form.resourceIds"
							:titles="['可用资源', '合并资源']"
							@change="handleChange"
							:props="{
								key: 'id',
								label: 'resourceName',
							}"
							:data="mergeList">
							<div slot-scope="{ option }">
								<!-- 分组标题 -->
								<div v-if="option.isGroup" style="font-weight: bold; color: #409eff">
									{{ option.resourceName }}
								</div>
								<!-- 普通项 -->
								<div v-else>
									<div>{{ option.resourceName }}</div>
								</div>
							</div>
						</el-transfer>
					</el-form-item>
				</el-col>
				<!-- 拆分数 -->
				<el-col :span="24">
					<el-form-item label="新资源编号" prop="newResourceNo">
						<el-input v-model="form.newResourceNo" size="small" placeholder="请填写新资源编号" />
					</el-form-item>
				</el-col>
				<!-- 拆分数 -->
				<el-col :span="24">
					<el-form-item label="新资源名称" prop="newResourceName">
						<el-input v-model="form.newResourceName" size="small" placeholder="请填写新资源名称" />
					</el-form-item>
				</el-col>
				<!-- 合同内容 -->
				<el-col :span="24">
					<el-form-item label="合并说明" prop="description">
						<el-input
							type="textarea"
							v-model="form.description"
							size="small"
							placeholder="请填写合并说明和原因"
							:rows="4" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { getResourceByPage, getResourceMerge } from '@/api/asset/resourceApi.js';
	import { getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'ResourceMergeDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.getList();
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				mergeList: [],
				form: {
					description: '',
					newResourceName: '',
					newResourceNo: '',
					resourceIds: [],
				},
				rules: {
					newResourceName: [{ required: true, message: '请填写新资源名称', trigger: 'blur' }],
					newResourceNo: [{ required: true, message: '请填写新资源编号', trigger: 'blur' }],
					resourceIds: [
						{
							required: true,
							validator: (rule, value, callback) => {
								if (!Array.isArray(value) || value.length === 0) {
									callback(new Error('请选择合并资源'));
								} else {
									callback();
								}
							},
							trigger: 'blur',
						},
					],
				},
				loading: false,
			};
		},
		methods: {
			groupByAsset(mergeList) {
				const groupMap = {};

				mergeList.forEach(item => {
					const key = item.assetId;

					if (!groupMap[key]) {
						groupMap[key] = {
							assetName: item.assetName,
							children: [],
						};
					}

					groupMap[key].children.push(item);
				});

				const result = [];

				Object.keys(groupMap).forEach(assetId => {
					const group = groupMap[assetId];

					// 1️⃣ 插入分组标题
					result.push({
						id: `group-${assetId}`,
						resourceName: group.assetName,
						assetName: group.assetName,
						isGroup: true,
						disabled: true,
					});

					// 2️⃣ 插入该组数据
					result.push(...group.children);
				});

				return result;
			},
			async getList() {
				try {
					this.loading = true;
					this.mergeList = [];
					const res = await getResourceByPage({
						currentStatus: 'AVAILABLE',
						communityId: getCommunityId(),
						page: 1,
						size: 999,
					});
					this.loading = false;
					this.mergeList = this.groupByAsset(res.records || []);
				} catch (err) {
					console.log(err);
				}
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			isSameGroup(selectedIds, sourceList) {
				if (!selectedIds || selectedIds.length === 0) return true;

				// 找到所有选中项对应的 assetId
				const assetIds = selectedIds.map(id => {
					const item = sourceList.find(i => i.id === id);
					return item.assetId;
				});

				// 去重
				const uniqueAssetIds = [...new Set(assetIds)];

				// 只要超过1个组，就不是同一组
				return uniqueAssetIds.length <= 1;
			},
			handleChange(newValue, direction, movedKeys) {
				console.log(newValue, direction, movedKeys);
				// 过滤掉分组标题（isGroup）
				const realSelected = newValue.filter(id => {
					const item = this.mergeList.find(i => i.id === id);
					return item && !item.isGroup;
				});

				const isValid = this.isSameGroup(realSelected, this.mergeList);

				if (!isValid) {
					this.$message.warning('只能选择同一个资产下的资源');

					this.form.resourceIds = this.form.resourceIds.filter(id => !movedKeys.includes(id));
					return;
				}

				// 正常逻辑
				this.form.resourceIds = newValue;
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					getResourceMerge(this.form)
						.then(() => {
							this.$message.success('合并资源成功');
							this.$emit('updateSuccess');
						})
						.catch(err => {
							console.log(err);
							this.$message.error('合并资源失败');
						})
						.finally(() => {
							this.handleClose();
						});
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		// .el-transfer-panel__item {
		// 	height: 60px;
		// }
		.el-dialog__body {
			padding-top: 10px;
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.msg {
		color: #333;
		margin-bottom: 5px;
	}
</style>
